import { ContainerModule } from "inversify";
import {
  AtualizarCertificadoGatewayDi,
  IAtualizarCertificadoGateway
} from "../services/AtualizarCertificadoGateway";
import { AtualizarCertificadoGatewayAdapter } from "../services/AtualizarCertificadoGatewayAdapter";

const atualizarCertificadoContainer = new ContainerModule((bind) => {
  bind<IAtualizarCertificadoGateway>(AtualizarCertificadoGatewayDi)
    .to(AtualizarCertificadoGatewayAdapter)
    .inSingletonScope();
});

export { atualizarCertificadoContainer };
